import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  containerContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    maxWidth: 900,
    width: '100%',
    margin: '0 auto',
    gap: theme.spacing(2)
  },
  writer: {
    fontWeight: 400
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    alignSelf: 'center',
    width: '60%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  image: {
    borderRadius: '30px'
  },
  altImage: {
    margin: '0 auto',
    textAlign: 'center',
    marginTop: theme.spacing(1)
  },
  tagsContainer: {
    display: 'flex',
    alignSelf: 'start',
    gap: theme.spacing(1),
    paddingTop: theme.spacing(2),
    flexWrap: 'wrap'
  },
  tags: {
    padding: theme.spacing(1, 2),
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.primary.dark,
    fontWeight: 500,
    borderRadius: '20px'
  }
}))
